
export enum QueryType {
    partnumber,keyword, family, search,merchgroup,url,fieldsearch,fbt, similar
}